// Keep the key consistent with helper-based storage: `streamrtv-` prefix
const PLUGIN_LIST_LOCALSTORAGE_KEY = 'streamrtv-pluginList';
// This class is currently not used as we only have the chat as a plugin.
// Having this class disabled helps with development as bad configs are not stored
export class PluginListStore {
    load() {
        try {
            const raw = localStorage.getItem(PLUGIN_LIST_LOCALSTORAGE_KEY);
            if (raw == null) {
                return undefined;
            }
            const parsedJson = JSON.parse(raw);
            return parsedJson;
        }
        catch (e) {
            console.warn('Failed to retrieve plugin list from localStorage', e);
            return undefined;
        }
    }
    save(state) {
        try {
            if (state == null) {
                localStorage.removeItem(PLUGIN_LIST_LOCALSTORAGE_KEY);
            }
            else {
                localStorage.setItem(PLUGIN_LIST_LOCALSTORAGE_KEY, JSON.stringify(state));
            }
        }
        catch (e) {
            console.warn('Failed to store plugin list in localStorage', e);
        }
    }
}
